import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@hweeks/kei-costs-ui-testids';
import { Container, SectionLabel } from '../../design';
import { CtaBand } from './CtaBand';
import { JP_FEES, TOC } from './GuidePage.data';
import { MKT, OFFICIAL } from './links';
import { MarketingLayout } from './MarketingLayout';
import './guide.css';
import { AnalyticsEvent, ctaEvent } from '../../utils/analytics';
// Ported from design-mockups/rhd-woodblock/Guide.dc.html. General guidance, not legal or customs
// advice: anything the design marked "owner to verify" is worded as indicative or
// "confirm with your broker" rather than stated as fact.
const YEARS = [
    '1996',
    '97',
    '98',
    '99',
    '2000',
    '01',
    '02',
    '03'
];
/** "Where Right Hand DMS helps" callout closing each section. */ function Helps({ children }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: "mk-guide__help",
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "mk-guide__help-seal",
                children: "右"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "mk-guide__help-text",
                children: [
                    /*#__PURE__*/ _jsx("b", {
                        children: "Where Right Hand DMS helps:"
                    }),
                    " ",
                    children
                ]
            })
        ]
    });
}
function Section({ n, k, title, children }) {
    return /*#__PURE__*/ _jsxs("section", {
        id: `s${n}`,
        className: "mk-guide__section",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "mk-guide__eyebrow",
                children: [
                    String(n).padStart(2, '0'),
                    " · ",
                    k
                ]
            }),
            /*#__PURE__*/ _jsx("h2", {
                className: "mk-guide__h2",
                children: title
            }),
            children
        ]
    });
}
export default function GuidePage() {
    return /*#__PURE__*/ _jsx(MarketingLayout, {
        testid: Testids.app.marketing.guideRoot,
        children: /*#__PURE__*/ _jsxs("main", {
            children: [
                /*#__PURE__*/ _jsxs("header", {
                    "data-screen-label": "Guide header",
                    className: "mk-guide__header mk-ground--kinari",
                    children: [
                        /*#__PURE__*/ _jsxs(Container, {
                            className: "mk-guide__head",
                            children: [
                                /*#__PURE__*/ _jsx(SectionLabel, {
                                    k: "案内",
                                    children: "Importing guide · for shops & dealers"
                                }),
                                /*#__PURE__*/ _jsx("h1", {
                                    className: "mk-guide__title",
                                    children: "Importing a vehicle from a Japanese auction, step by step"
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "mk-guide__lead",
                                    children: "Stagea, Land Cruiser, Delica or kei truck, from the 25-year rule to a title in your state. It’s written for businesses buying through an export agent. Treat every fee, rate, tax and timeline here as illustrative. They move constantly, and your agent, broker and carrier set the real numbers."
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "mk-guide__meta",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            children: "9 sections · ~15 min read"
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            children: "Updated Oct 2026"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(Container, {
                            className: "mk-guide__strip-wrap",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mk-guide__strip",
                                    children: TOC.map((t)=>/*#__PURE__*/ _jsxs("a", {
                                            href: t.href,
                                            className: "mk-guide__stop",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-guide__stop-k",
                                                    children: t.k
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-guide__stop-name",
                                                    children: t.short
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-guide__stop-time",
                                                    children: t.time
                                                })
                                            ]
                                        }, t.n))
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mk-guide__strip-note",
                                    children: "Durations are illustrative. Shipping schedules swing widely, and yours will differ."
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(Container, {
                    className: "mk-guide__body",
                    children: [
                        /*#__PURE__*/ _jsxs("aside", {
                            className: "mk-guide__aside",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mk-guide__aside-head",
                                    children: "目次 · Contents"
                                }),
                                TOC.map((t)=>/*#__PURE__*/ _jsxs("a", {
                                        href: t.href,
                                        className: "mk-guide__aside-link",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "mk-guide__aside-n",
                                                children: t.n
                                            }),
                                            t.title
                                        ]
                                    }, t.n))
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("article", {
                            className: "mk-guide__article",
                            children: [
                                /*#__PURE__*/ _jsxs("details", {
                                    className: "mk-guide__toc",
                                    children: [
                                        /*#__PURE__*/ _jsxs("summary", {
                                            className: "mk-guide__toc-q",
                                            children: [
                                                "目次 · Contents",
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "rhd-plus",
                                                    children: "+"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mk-guide__toc-list",
                                            children: TOC.map((t)=>/*#__PURE__*/ _jsxs("a", {
                                                    href: t.href,
                                                    className: "mk-guide__toc-link",
                                                    children: [
                                                        t.n,
                                                        " · ",
                                                        t.title
                                                    ]
                                                }, t.n))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Section, {
                                    n: 1,
                                    k: "規則",
                                    title: "The 25-year rule",
                                    children: [
                                        /*#__PURE__*/ _jsx("p", {
                                            children: "Japanese-market vehicles weren’t built to US safety and emissions standards. They can still come in for road use, because a vehicle 25 years or older (counted from the month of manufacture) is exempt from FMVSS. EPA exempts vehicles that old as well."
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-guide__panel mk-guide__panel--pad",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "mk-guide__panel-caps",
                                                    children: "Importable in 2026"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "mk-guide__years",
                                                    children: YEARS.map((y, i)=>/*#__PURE__*/ _jsx("span", {
                                                            className: `mk-guide__year${i < 6 ? ' mk-guide__year--ok' : ''}${i === 5 ? ' mk-guide__year--last' : ''}`,
                                                            children: y
                                                        }, y))
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "mk-guide__note",
                                                    children: "Model year 2001 and older. A late-2001 build doesn’t clear until its 25th anniversary month."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            children: "Sheets give the year in the Japanese era: H11 is Heisei 11, which is 1999. Whether an import can be titled and driven on public roads is up to your state, so ask your DMV or title office."
                                        }),
                                        /*#__PURE__*/ _jsx(Helps, {
                                            children: "search starts on importable model years, and every sheet read converts the era year for you."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Section, {
                                    n: 2,
                                    k: "代理",
                                    title: "Choosing an export agent",
                                    children: [
                                        /*#__PURE__*/ _jsx("p", {
                                            children: "Japanese dealer auctions are members-only. An export agent bids for you, pays the auction, handles deregistration and books shipping. When you compare agents, look at the per-car fee, the deposit terms, how fast they send sheets and extra photos, and what they do about damage claims. Plenty of shops hold accounts with more than one agent to see more lots."
                                        }),
                                        /*#__PURE__*/ _jsxs(Helps, {
                                            children: [
                                                "one search across your JapanCarDirect, JDM Auc and Pacific Coast JDM accounts.",
                                                ' ',
                                                /*#__PURE__*/ _jsx("a", {
                                                    href: MKT.bookCall,
                                                    ...ctaEvent(AnalyticsEvent.ctaBookCall, 'guide'),
                                                    children: "Use another agent? Ask us →"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Section, {
                                    n: 3,
                                    k: "査定",
                                    title: "Reading an auction sheet",
                                    children: [
                                        /*#__PURE__*/ _jsx("p", {
                                            children: "The auction house inspects every lot. Its sheet has an overall grade, interior and exterior grades, mileage, options, a damage map and the inspector’s handwritten notes."
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-guide__panel mk-guide__grades",
                                            children: [
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "mk-guide__grade",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "mk-guide__grade-v",
                                                            children: "4.5–6, S"
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "mk-guide__grade-t",
                                                            children: "Very clean to near-new"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "mk-guide__grade",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "mk-guide__grade-v",
                                                            children: "3.5–4"
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "mk-guide__grade-t",
                                                            children: "Normal wear for age"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "mk-guide__grade",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "mk-guide__grade-v",
                                                            children: "1–3"
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "mk-guide__grade-t",
                                                            children: "Heavy wear or issues"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "mk-guide__grade",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "mk-guide__grade-v",
                                                            children: "R / RA"
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "mk-guide__grade-t",
                                                            children: "Repaired accident history"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            children: "Damage codes pair a letter with a size: A scratch, U dent, W repair wave, S rust, C corrosion. Bigger number, bigger problem. On 4x4s and trucks, read the underbody notes closely."
                                        }),
                                        /*#__PURE__*/ _jsxs(Helps, {
                                            children: [
                                                "each sheet comes back in structured English, frame number included when it’s legible. ",
                                                /*#__PURE__*/ _jsx("a", {
                                                    href: MKT.product('auction-sheets'),
                                                    children: "Auction sheets →"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Section, {
                                    n: 4,
                                    k: "入札",
                                    title: "Bidding and the fees to expect",
                                    children: [
                                        /*#__PURE__*/ _jsx("p", {
                                            children: "You give the agent a maximum bid. If you win, the hammer price is only the start. On the Japan side, expect fees like these (illustrative):"
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-guide__panel mk-guide__fees",
                                            children: [
                                                JP_FEES.map(([label, value], i)=>/*#__PURE__*/ _jsxs("div", {
                                                        className: `mk-guide__fee${i === JP_FEES.length - 1 ? ' mk-guide__fee--last' : ''}`,
                                                        children: [
                                                            /*#__PURE__*/ _jsx("span", {
                                                                children: label
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "mk-guide__fee-v",
                                                                children: value
                                                            })
                                                        ]
                                                    }, label)),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "mk-guide__fees-note",
                                                    children: "Illustrative only. These ranges come from one real five-vehicle shipment in Aug 2026. Agent fees, freight and exchange rates change all the time, and your agent’s invoice is what counts."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            children: "Japanese taxes and charges on exported vehicles change too. Your agent works them out and puts them on the invoice. Right Hand DMS records what you were charged."
                                        }),
                                        /*#__PURE__*/ _jsx(Helps, {
                                            children: "bid ranges come from similar lots that sold, and after the auction the result check asks you to confirm each win."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Section, {
                                    n: 5,
                                    k: "送金",
                                    title: "Paying: Wise or wire",
                                    children: [
                                        /*#__PURE__*/ _jsx("p", {
                                            children: "Agents invoice in yen and expect payment soon after the auction, so check your agent’s terms. The ¥/$ rate printed on the invoice can move from one invoice to the next (159.50 to 163.80 in one recent shipment), which is why you record FX per invoice. A Wise transfer often costs less than a bank wire and shows the exact rate you got. Keep the confirmation, whatever you use. That rate is what the car cost you in dollars."
                                        }),
                                        /*#__PURE__*/ _jsx(Helps, {
                                            children: "drop in the transfer and yen lines can use its rate."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Section, {
                                    n: 6,
                                    k: "輸出",
                                    title: "Export, deregistration and RoRo shipping",
                                    children: [
                                        /*#__PURE__*/ _jsx("p", {
                                            children: "Your agent deregisters the car and issues an export certificate. Get the original and an English translation, since customs and the title office both want it. Most cars ship RoRo, which means they’re driven onto a vehicle carrier with no container. The bill of lading names the frame number."
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-guide__route",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-guide__route-stop",
                                                    children: "Auction yard"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "→"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-guide__route-stop",
                                                    children: "Agent yard"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "→"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-guide__route-stop",
                                                    children: "JP port"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "→"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-guide__route-stop mk-guide__route-stop--sea",
                                                    children: "RoRo · varies"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "→"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-guide__route-stop",
                                                    children: "US port"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Helps, {
                                            children: "the bill of lading is recognised and filed against the car, and one tap moves the car to Importing."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Section, {
                                    n: 7,
                                    k: "通関",
                                    title: "Customs: the broker, CBP 7501, duty, MPF and HMF",
                                    children: [
                                        /*#__PURE__*/ _jsx("p", {
                                            children: "A licensed customs broker files your entry. You’ll need the bill of lading, the agent’s commercial invoice, the export certificate, and EPA 3520-1 and DOT HS-7 forms declaring the 25-year exemption. The entry summary (CBP Form 7501) shows what you paid. On one recent entry the entered value was the vehicle price alone, without the service fees in the invoice FOB. Ask your broker which applies to you."
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            children: "Tariff rates on Japanese vehicles have changed several times since 2025 and are still moving. Your broker classifies the vehicle and sets the rate. Right Hand DMS doesn’t do either. We take what you were charged off your paperwork and add it to the car’s landed cost."
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-guide__panel",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "mk-guide__duty-caps",
                                                    children: "On the 7501"
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "mk-guide__duty",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("b", {
                                                            children: "Duty"
                                                        }),
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "mk-guide__duty-v",
                                                            children: "As filed"
                                                        }),
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "mk-guide__duty-t",
                                                            children: "Recently 12.5–25% of the value. The rate depends on how your broker classifies the vehicle and on the tariffs in force the day it enters, and those change often. Ask your broker before you bid."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "mk-guide__duty",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("b", {
                                                            children: "MPF (Merchandise Processing Fee)"
                                                        }),
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "mk-guide__duty-v",
                                                            children: "As filed"
                                                        }),
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "mk-guide__duty-t",
                                                            children: "a percentage of entered value, with a minimum and maximum set each fiscal year"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "mk-guide__duty",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("b", {
                                                            children: "HMF (Harbor Maintenance Fee)"
                                                        }),
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "mk-guide__duty-v",
                                                            children: "As filed"
                                                        }),
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "mk-guide__duty-t",
                                                            children: "a percentage of value for ocean shipments"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs(Helps, {
                                            children: [
                                                "drop in the 7501 and the broker’s invoice. Duty, MPF and HMF come up for you to check, then go on the car’s cost sheet.",
                                                ' ',
                                                /*#__PURE__*/ _jsx("a", {
                                                    href: MKT.product('landed-cost'),
                                                    children: "Landed cost →"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Section, {
                                    n: 8,
                                    k: "引取",
                                    title: "Port pickup and trucking",
                                    children: [
                                        /*#__PURE__*/ _jsx("p", {
                                            children: "Once customs releases the car, the terminal charges handling, plus storage when its free days run out. Book your carrier before release so storage doesn’t stack up. Hang on to every terminal and trucking receipt. They’re part of what the car cost."
                                        }),
                                        /*#__PURE__*/ _jsx(Helps, {
                                            children: "port and trucking receipts are recognised and linked to the car."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Section, {
                                    n: 9,
                                    k: "登録",
                                    title: "Title and registration",
                                    children: [
                                        /*#__PURE__*/ _jsx("p", {
                                            children: "Requirements vary by state. Most ask for the stamped 7501, the translated export certificate, a bill of sale, and an inspection of the frame number. Ask your state DMV or title office what it needs before you buy."
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-guide__aside-note",
                                            children: [
                                                "Before you buy, check your state’s rules for titling imported vehicles.",
                                                ' ',
                                                /*#__PURE__*/ _jsx("a", {
                                                    href: OFFICIAL.dmv.href,
                                                    children: "Find your state’s motor vehicle office"
                                                }),
                                                ". For the federal side, see ",
                                                /*#__PURE__*/ _jsx("a", {
                                                    href: OFFICIAL.cbp.href,
                                                    children: "CBP"
                                                }),
                                                ",",
                                                ' ',
                                                /*#__PURE__*/ _jsx("a", {
                                                    href: OFFICIAL.epa.href,
                                                    children: "EPA"
                                                }),
                                                " and ",
                                                /*#__PURE__*/ _jsx("a", {
                                                    href: OFFICIAL.nhtsa.href,
                                                    children: "NHTSA"
                                                }),
                                                "."
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Helps, {
                                            children: "the title receipt closes out the car’s cost. Record the sale and you’ll see your profit."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(CtaBand, {
                    title: "Questions about your import process?",
                    sub: "Tell us if you run a dealership or you’re bringing in a car of your own. We’ll walk through where Right Hand DMS fits."
                })
            ]
        })
    });
}
